export var EEventStatus;
(function (EEventStatus) {
    EEventStatus[EEventStatus["CREATED"] = 0] = "CREATED";
    EEventStatus[EEventStatus["CANCELLED"] = 1] = "CANCELLED";
    EEventStatus[EEventStatus["PUBLISHED"] = 2] = "PUBLISHED";
    EEventStatus[EEventStatus["FINISHED"] = 3] = "FINISHED";
})(EEventStatus || (EEventStatus = {}));
export const getEventStatus = (status) => {
    switch (status) {
        case EEventStatus.CREATED:
            return 'Создан';
        case EEventStatus.PUBLISHED:
            return 'Опубликован';
        case EEventStatus.CANCELLED:
            return 'Отменен';
        case EEventStatus.FINISHED:
            return 'Закончен';
        default:
            return 'Создан';
    }
};
